import React from "react";
import Tabs from "../../../../components/elements/Tabs";
import GlobalCheckoutFormEvent from "../../../../components/sections/front/event-checkout-form/GlobalCheckoutFormEvent";
import { useMutation } from "@tanstack/react-query";
import { eventStatusChange } from "../../../../services/eventService";
import { useOutletContext } from "react-router-dom";
import { classNames } from "../../../../helpers/classNames";
import { t } from "i18next";

const CheckOutForm = () => {
  const { event, eventLoading, eventOrganizer, eventDetailsRefetch } =
    useOutletContext();

  const { mutate: eventFormChangeHandler, isPending } = useMutation({
    mutationFn: async (value) => {
      const res = await eventStatusChange({
        checkoutForm: value,
        ids: [event?.data?._id],
      });
      return res;
    },
    onSuccess: (res) => {
      if (res?.status === 200) {
        eventDetailsRefetch();
      }
    },
  });

  const tabItems = [
    {
      label: t("Global"),
      value: "custom",
      content: (
        <div className="relative">
          <GlobalCheckoutFormEvent readOnly type="custom" />
          {(isPending || eventLoading) && (
            <div className="absolute top-0 left-0 w-full h-full backdrop-blur-[2px] z-[1] flex flex-col space-y-1 justify-center items-center">
              <i class="fa-solid fa-circle-notch text-2xl animate-spin"></i>
              <div className="text-center font-semibold text-lg">
                {t("Please wait")}...
              </div>
            </div>
          )}
        </div>
      ),
    },
    {
      label: t("Custom"),
      value: "event",
      content: (
        <div className="relative">
          <GlobalCheckoutFormEvent type="event" />
          {(isPending || eventLoading) && (
            <div className="absolute top-0 left-0 w-full h-full backdrop-blur-[2px] z-[1] flex flex-col space-y-1 justify-center items-center">
              <i class="fa-solid fa-circle-notch text-2xl animate-spin"></i>
              <div className="text-center font-semibold text-lg">
                {t("Please wait")}...
              </div>
            </div>
          )}
        </div>
      ),
    },
  ];

  return (
    <div className="bg-white h-full rounded-lg">
      <Tabs
        items={tabItems}
        selectedIndex={tabItems?.findIndex(
          (item) => item?.value === event?.data?.checkoutForm
        )}
        onChange={(val) => {
          eventFormChangeHandler(val?.value);
        }}
        contentClass={classNames("w-full")}
        tabsClass="gap-3 p-5 flex items-center gap-4"
        tabClass={
          "h-11 rounded-full bg-transparent border border-gray-200 flex items-center justify-center !text-deep-purple p-5 text-base capitalize font-normal"
        }
        activeTabClass={"bg-primary border border-primary !text-white"}
      />
    </div>
  );
};

export default CheckOutForm;
